import InfoCard from "@pages/tablet/residences/components/InfoCard"
import useStore from "@state/store"
import styled from "styled-components"

interface ISingleUnitScreenProps {
  selectedRows: any
}

export default function SingleUnitScreen(props: ISingleUnitScreenProps) {
  // This is weird as sometimes is an array and sometimes is an object.. that is an anti pattern..
  // you should have it as an array of one object or two instead if you want to decide between compare or display.
  const { selectedRows } = props
  const { activeDuplexFloorplan, compareSection, activeView } = useStore(
    (state) => ({
      activeDuplexFloorplan: state.activeDuplexFloorplan,
      compareSection: state.compareSection,
      activeView: state.activeView,
    }),
  )
  const exceptions = ["PH16A", "PH16D", "PH16E", "PH17A"]

  const _isAnObject = (unit: any) => {
    return typeof unit === "object" && !Array.isArray(unit) && unit != undefined
  }

  const _isAnArrayWithValuesIn = (unit: any) => {
    return Array.isArray(unit) && unit.filter(Boolean).length > 0
  }

  const isDuplex = (unit: any) => {
    return (
      unit?.unitType?.startsWith("TH") ||
      (unit?.unitType?.startsWith("PH") && !exceptions.includes(unit?.unitType))
    )
  }

  return (
    <Wrapper>
      <div
        className={`no-unit ${!_isAnObject(selectedRows) || !_isAnArrayWithValuesIn(selectedRows) ? "visible" : "hidden"}`}
      >
        Select a unit to view
      </div>
      <div
        className={`single-unit ${_isAnObject(selectedRows) || _isAnArrayWithValuesIn(selectedRows) ? "visible" : "hidden"}`}
      >
        {compareSection === "floorplan" && (
          <div>
            <div className="residence-info">
              <InfoCard selectedUnit={selectedRows} />
            </div>
            <div className="unit-floorplan">
              {selectedRows?.unitType && (
                <img
                  src={`/assets/images/residences/floorplans/${selectedRows?.unitType}-F${isDuplex(selectedRows) ? "-" + activeDuplexFloorplan : ""}.png`}
                  alt="Floorplan"
                />
              )}
            </div>
            <div className="unit-floorplate">
              {selectedRows?.unitType && (
                <img
                  alt="Floorplan"
                  src={`/assets/images/residences/floorplans/${selectedRows?.unitType}-P${isDuplex(selectedRows) ? "-" + activeDuplexFloorplan : ""}.png`}
                />
              )}
            </div>
          </div>
        )}
        {compareSection === "view" && (
          <div className="compare-unit">
            <img
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              className="img"
              src={`/assets/images/residences/views/${activeView}`}
              alt="Floorplan 2"
            />
          </div>
        )}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 100%;
  width: 100%;

  .no-unit {
    text-transform: uppercase;
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;
    transform: translate(-50%, -50%);
    transition: opacity 0s ease-in;

    &.visible {
      opacity: 1;
      transition: opacity 0.6s ease-in;
    }
  }

  .single-unit {
    width: 100%;
    height: 100%;
    position: relative;
    opacity: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: all 0.6s;

    &.hidden {
      opacity: 0;
      transition: all 0.3s;
    }

    .residence-info {
      position: relative;
      width: 100%;
      height: 25%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);

      .unit-info {
        transform: scale(1.2);
        transform-origin: left;
      }

      .duplex-toggle {
        display: flex;
        font-weight: bold;

        &.show {
          opacity: 1;
          margin-left: 0em;
          pointer-events: auto;
          transition: all 0.3s ease-in-out;
        }

        &.hide {
          opacity: 0;
          margin-left: -5em;
          pointer-events: none;
          transition: all 0.3s ease-in-out;
        }

        span {
          color: #000;
          font-size: 1.3em;
          background: none;
          padding: 0.5em 1em;
          border: 1px solid #000;
          transition: all 0.3s ease-in-out;

          &.active {
            background-color: rgba(0, 0, 0, 0.8);
            color: white;
          }
        }
      }

      .separator-root[data-orientation="vertical"] {
        height: 100%;
        width: 0.5px;
        margin: 0 10px;
        background-color: #000;
      }
    }

    .unit-floorplan {
      height: 75vh;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5em;

      img {
        object-fit: contain;
        width: 100%;
        height: 90%;
        margin-bottom: auto;
      }
    }

    .unit-floorplate {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 1em;
      height: 15em;

      img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }
  }

  .single-unit.visible {
    opacity: 1;
    transition: all 0.6s;
  }
`
